import React from 'react';
import BillingStatusBadge from 'components/v2/BillingStatusBadge';
export default function OrderBillingStatus({ className = '', billingStatus, }) {
    return (React.createElement(BillingStatusBadge, { className: className, billingStatus: billingStatus }));
}
